import { createApp } from 'vue'
import App from './App.vue'
import './service'

createApp(App).mount('#app')
